import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { Statistics } from '../../entity';

@Component({
    selector: 'app-fines-chart',
    templateUrl: './fines-chart.component.html'
})
export class FinesChartComponent implements OnInit, OnChanges {
    @Input() fineStatistics: Array<Statistics>;
    totalFinesNumberArray: Array<number>;
    totalFinesAmountArray: Array<number>;

    public lineChartData: Array<any> = [
        { data: [this.totalFinesNumberArray], label: 'Number' },
    ];
    public lineChartLabels: Array<any> = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    public lineChartOptions: any = {
        responsive: true,
        maintainAspectRation: true,
        scales: {
            yAxes: [{
                ticks: {
                    beginAtZero: true
                }
            }]
        }
    };
    public lineChartColors: Array<any> = [
        {
            backgroundColor: 'rgba(255, 91, 121, 0.6)', // rosu
            pointBackgroundColor: 'rgb(255, 91, 121)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#ff5b79',
            pointHoverBorderColor: 'rgba(255, 91, 121, 1)'
        },
        {
            backgroundColor: 'rgba(255, 239, 178, 0.6)',
            pointBackgroundColor: 'rgb(255, 239, 178)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(148,159,177,0.8)'
        }
    ];
    public lineChartLegend = false;
    public lineChartType = 'line';

    constructor() { }

    ngOnInit() {
        this.refresh();
    }

    ngOnChanges() {
        this.refresh();
    }

    refresh() {
        const _lineChartData = [
            { data: new Array(this.lineChartData[0].data.length), label: this.lineChartData[0].label },
            // { data: new Array(this.lineChartData[1].data.length), label: this.lineChartData[1].label }
        ];

        this.fineStatistics.forEach((item, index) => {
            _lineChartData[0].data[index] = item.TotalNumber;
            // _lineChartData[1].data[index] = item.TotalAmount;
        });
        this.lineChartData = _lineChartData;
    }
}
